<template>
<el-main v-loading="loading">
  <div>
    <center-nav v-if="isPay == 'true'"></center-nav>
    <div class="center-auto">
      <div class="auth-wrap">
        <div class="auth-status" v-if="isPay == 'true'">
          <img src="@/assets/img/pay_icon_pay_succeed.png" alt="" />
          <div class="success">
            <div class="success-title">付款成功</div>
            <div class="success-text">支付单号：{{ transactionId }}</div>
          </div>
        </div>
        <div class="status-text" v-if="isPay == 'true'">
          套餐版本购买成功后，<span style="font-weight: bold;">请填写渠道商城名称。</span>填写之后，点击下方按钮，查看接入文档
        </div>
        <div class="auth-box">
          <el-row>
            <el-col :span="6" class="auth-logo-div">
              <img
                class="auth-logo"
                src="@/assets/img/official/wechat_shouquanshuoming.png"
                alt=""
              />
            </el-col>
            <el-col :span="18">
              <div style="display: flex;align-items: center;">
                <div style="width: 84px;position: relative;">
                  <div>渠道商城名称</div>
                  <div style="position: absolute;font-size: 10px;color: #999;right: 0;">必填，不可修改</div>
                </div>
                <el-input v-model="name" style="width: 350px;margin: 0 10px;" placeholder="请输入渠道商城名称:" maxlength="20" show-word-limit :disabled="!!channelAppkey"></el-input>
<!--                <span style="color: #999;font-size: 12px;">必填项，不可修改</span>-->
                <el-button :type="(!!channelAppkey || !name) ?'info' : 'warning'" :disabled="!!channelAppkey || !name" :loading="channelAppkeyLoading" @click="getAppKey">保存并获取appKey</el-button>
              </div>
              <div v-if="channelAppkey" style="display: flex; align-items: center;margin-top: 10px;height: 70px;font-size: 16px;">
                <div style="width: 84px;text-align: right;margin-right: 10px;">appKey:</div>
                <span style="color: #3D9EFC;margin-right: 10px;">{{channelAppkey}}</span>
                <el-tag style="cursor: pointer;" size="small" v-clipboard:copy="channelAppkey"
                 v-clipboard:success="onCopy">复制</el-tag>
              </div>
              <div style="display: flex;margin-top: 100px;margin-left: 200px;">
                <el-link style="font-size: 24px;" type="primary" :disabled="!channelAppkey" @click="goDocumentation">查看接入流程</el-link>
<!--                <el-button type="warning" style="margin-top: 40px;padding: 10px 80px;" :loading="submitLoading" @click="goDocumentation2">接入流程测试</el-button>-->
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</el-main>
</template>

<script>
import SyncTemplate from "@/components/official/SyncTemplate.vue";
import Admin from "@/components/official/Admin.vue";
import {
  getUserUUID,
  getNickname,
  getPlatformUuid,
  getPlatformName,
  getHeadImg,
  getIsAuthOfficial,
  getSnaphotId,
  getIsBasic,
} from "@/utils/auth";
import official from "@/javaApi/official";
const officialModel = new official();
import centerNav from "@/components/centerNav";

import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  name: "Authorization",
  components: {
    SyncTemplate,
    Admin,
    centerNav,
  },
  data: function () {
    return {
      loading:false,
      urls: "",
      isBasic: getIsBasic() === "true" ? true : false, //是否是基础版本
      listLoading: false,
      userUUID: getUserUUID(),
      bindPackage: [],
      publicInfo: [],
      authLink:
        process.env.VUE_APP_MOVIE_DOMAIN +
        "javaopen/movie/open/auth/mini-auth?userUUID=" +
        getUserUUID() +
        "&goUrl=" +
        encodeURIComponent(
          encodeURIComponent(
            "http://movie-test.taototo.cn/#/pc/channelMiniProgram/home?isAuto=1" +
              "&pitId=" +
              this.$route.query.pitIdZfb
          )
        ) +
        "&pitId=" +
        this.$route.query.pitIdZfb +
        "&buttonText=点击开始授权小程序",
      promotionLink:
        process.env.VUE_APP_MOVIE_PROMOTION_URL +
        "yp-api/movie/wx/pub-login?platformUuid=" +
        getPlatformUuid() +
        "&type=1",
      personalLink:
        process.env.VUE_APP_MOVIE_PROMOTION_URL +
        "yp-api/movie/wx/pub-login?platformUuid=" +
        getPlatformUuid() +
        "&type=personal", //个人中心链接
      posterLink:
        process.env.VUE_APP_MOVIE_PROMOTION_URL +
        "yp-api/movie/wx/pub-login?platformUuid=" +
        getPlatformUuid() +
        "&type=poster", //邀请好友链接
      authStep: getIsAuthOfficial() === "true" ? 2 : 1,
      headImg: getHeadImg(),
      platformName: getPlatformName(),
      transactionId: "", // 支付单号
      isPay: false, // 是否购买过了
      pitIdZfb: "", // 授权的套餐id
      shows:false,
      name:'',
      channelAppkey:'',
      submitLoading:false,
      channelAppkeyLoading:false,
      disabledName:false,
    };
  },
  created() {
    // this.getzfbMiniAuth();
    // this.mallChannelKey()
  },
  mounted() {
    this.transactionId = this.$route.query.transactionId;
    // 判断是否购买了
    this.isPay = this.$route.query.isPay;
    console.log("this.isPay", this.isPay);
    console.log(this.$route.query, "this.$route.query==", this.pitIdZfb);
    // 当没有pitId时取套餐席位第一个
    if (
      this.$route.query.pitIdZfb === undefined &&
      this.$parent.packagePitList[0]
    ) {
      this.$route.query.pitIdZfb = this.$parent.packagePitList[0].id;
      // 重新在赋值一遍避免pitId变成undefined
      // this.authLink =
      //   process.env.VUE_APP_MOVIE_DOMAIN +
      //   "javaopen/movie/open/auth/mini-auth?userUUID=" +
      //   getUserUUID() +
      //   "&goUrl=" +
      //   encodeURIComponent(
      //     encodeURIComponent(
      //       "http://movie-test.taototo.cn/#/pc/channelMiniProgram/home?isAuto=1"
      //     )
      //   ) +
      //   "&pitId=" +
      //   this.$route.query.pitIdZfb +
      //   "&buttonText=点击开始授权小程序";
    }
    // this.getzfbMiniAuth();
    // 判断是否是商户
    localStorage.removeItem("isMerchant");
    console.log(this.authLink, "this.authLinkthis.authLink");
  },
  methods: {
    async mallChannelKey() {
      const res = await MiniModel.getChannelMallAppKey({
        id: this.$route.query.pitIdZfb,
      })
      console.log(res,'查询 - 渠道商城的appKey')
      if(res.data.code!== 200) {
        this.$message.error(res.data.message || res.data.info)
        return;
      }
      this.channelAppkey = res.data.data
    },
    async getAppKey() {
      if(!this.name) {
        this.$message.error('请填写渠道商城名称');
        return;
      }
      if(!/^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(this.name)) {
        this.$message.error('渠道商城名称不能有特殊字符');
        return;
      }
      this.channelAppkeyLoading = true
      const res = await MiniModel.addChannelMallAppKey({
        // appKey: this.channelAppkey,
        channelMallName: this.name,
        pitId: this.$route.query.pitIdZfb,
      })
      console.log(res,'添加 - 渠道商城')
      this.channelAppkeyLoading = false
      if(res.data.code !== 200) {
        this.$message.error(res.data.message || res.data.info)
        return;
      }
      this.channelAppkey = res.data.data
      this.$message.success('保存成功');
      // const res = await MiniModel.getChannelAppKey({
      //   id: this.$route.query.pitIdZfb,
      // })
      // console.log(res,'获取 - 渠道商城的appKey')
    },
    async goDocumentation() {
      // this.$emit('openSet','')
      setTimeout(()=> {
        window.open('https://apifox.com/apidoc/shared-a194c212-6a38-45e3-b3e0-ec970864eca6')
      },10)
      let res = await MiniModel.getMiniNum({
        channelType:7
      })
      if(res.data.code !== 200) {
        this.$message.error(res.data.message || res.data.info)
        return;
      }
      console.log(res.data.data.openAppList,'res.data.data.openAppList',this.channelAppkey,'this.channelAppkey')
      if(res.data.data.openAppList.length) {
        let index = res.data.data.openAppList.findIndex(item => {
          return item.appKey === this.channelAppkey
        })
        console.log(index,'miniActiveChannel=index')
        if(index > -1) {
          localStorage.setItem('miniActiveChannel',index)
        }
      }
      this.$router.push({
        path:'/pc/channelMiniProgram/set'
      })
    },
    goDocumentation2() {
      // this.$router.push({
      //   path:'/pc/channelMiniProgram/set'
      // })
      // this.$emit('openSet','')
      // window.open('https://apifox.com/apidoc/shared/bdf73572-04b2-406e-ab0d-917426c83209/doc-6048368')
    },
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
    async getzfbMiniAuth() {
      if (
        this.$route.query.pitIdZfb === undefined &&
        this.$parent.packagePitList[0]
      ) {
        this.$route.query.pitIdZfb = this.$parent.packagePitList[0].id;
      }
      let params = {
        pitId: this.$route.query.pitIdZfb,
      };
      console.log(params, "paramsparams=获取url");
      this.loading = true
      console.log(this.loading,'this.loading==1')
      try {
        let res = await MiniModel.zfbMiniAuth(params);
        console.log(res, "getzfbMiniAuth");
        if (res.data.code == 200) {
          this.shows = true
          this.urls = res.data.data;
          this.loading = false
          console.log(this.loading,'this.loading==2')
        }else{
          this.$message.error(res.data.message || res.data.info)
          this.loading = false
        }
      } catch (error) {
        this.$message.error(res.data.message || res.data.info)
        this.loading = false
      }
    },
    syncTemplate: function () {
      this.$refs.template.init();
      //https://test.taototo.cn/movie/api/template/addOneTemplate?platformUUID=xxxx
      console.log("同步消息模板");
    },
    bindWechatAdmin: function () {
      this.$refs.admin.init();
      //https://test.taototo.cn/movie/api/dis.user/bindAdmin?adminPlatform=XXXX ---这个是绑定微信管理员 - 扫码绑定（获取二维码链接）
      console.log("绑定微信管理员");
    },
    copyLink: function (link) {
      var that = this;
      this.$copyText(link).then(
        function (e) {
          that.$Message.success("复制成功");
        },
        function (e) {
          that.$Message.error("复制失败,请升级浏览器版本！");
        }
      );
    },
    bindBtn() {
      console.log("debug:________________bindBtn______________");
      localStorage.removeItem("isMerchant");
    },
  },
};
</script>
<style>
html {
  background: #f5f5fa;
}
</style>
<style scoped lang="less">
@media screen and (max-width: 1750px) {
  .center-auto {
    margin: 20px 60px !important;
  }
}
.center-auto {
  margin: 20px 260px;
  background: #ffffff;
  height: 100%;
  //box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 6%);
  border-radius: 8px;
}
.margin-left-10 {
  margin-left: 10px;
}
.margin-right-10 {
  margin-right: 10px;
}
.center-auto .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}
.auth-wrap .auth-box {
  padding: 60px 214px;
}
.auth-wrap .auth-box .auth-logo-div {
  padding-right: 30px;
}
.auth-wrap .auth-box .auth-logo {
  width: 100%;
  padding-top: 30px;
}
.auth-wrap .auth-box .auth-title,
.auth-detail .auth-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}
.auth-wrap .auth-box .auth-tip,
.auth-detail .auth-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #666666;
  margin-top: 10px;
}
.auth-wrap .auth-box .part-box,
.auth-detail .part-box {
  display: flex;
  flex-direction: row;
  padding: 4px 0;
}
.auth-wrap .auth-box .part-circle,
.auth-detail .part-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #d63036;
  margin: 5px 8px 5px 0;
}
.auth-detail .part-circle {
  background: #999999;
}
.auth-wrap .auth-box .part-content,
.auth-detail .part-content {
  width: 90%;
}
.auth-wrap .auth-box .btn-box {
  padding-top: 5px;
  background: #ff8622;
  margin-right: 20px;
}

.auth-wrap .auth-box .btn-box .auth-btn {
  font-family: Alibaba-PuHuiTi-R;
  background: #ff8622;
  border-radius: 2px;
  color: #ffffff;
  //padding: 20px;
}
.auth-wrap .auth-box .btn-box .auth-btn a {
  color: #ffffff;
}
.auth-detail {
  padding-top: 30px;
  min-width: 900px;
}
.auth-detail .left-box {
  padding-right: 20px;
}
.auth-detail .left-box .detail-box {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  min-width: 440px;
}
.auth-detail .left-box .detail-box .detail-div {
  padding: 20px 20px 160px 20px;
}
.auth-detail .left-box .detail-box .detail-div .operate-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #ff8622;
  padding: 10px 0;
}
.auth-detail .left-box .detail-box .detail-div .operate-div img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.auth-detail .left-box .detail-box .detail-div .operate-div .wechat-title {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #666666;
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}
.auth-detail .left-box .detail-box .detail-div .operate-div .wechat-btn {
  border: 1px solid #ff8622;
  padding: 6px 15px;
  cursor: pointer;
}
.auth-detail .left-box .detail-box .detail-div .link-div {
  padding-top: 20px;
}
.auth-detail .left-box .detail-box .detail-div .link-title {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #222222;
}
.auth-detail .left-box .detail-box .detail-div .link {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #3d9efc;
  padding: 6px 0;
  display: flex;
}
.auth-detail .left-box .detail-box .detail-div .link label {
  width: 100px;
  color: #222222;
}
.auth-detail .left-box .detail-box .detail-div .link-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #666666;
}
.auth-detail .right-box {
  padding-left: 20px;
}
.auth-detail .right-box .notice-box {
  min-width: 380px;
}
.auth-detail .right-box .notice-box .qrcode-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
}
.auth-detail .right-box .notice-box .qrcode-box .qrcode-div {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  width: 180px;
  padding: 20px;
}
.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .qrcode-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
}
.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .nickname {
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #222222;
}
.auth-detail .part-content .sync-template {
  color: #ff4f76;
  padding-left: 5px;
  cursor: pointer;
}
.copy-btn {
  border: 1px solid #ff8622;
  padding: 6px 15px;
  cursor: pointer;
  color: #ff8622;
  white-space: nowrap;
}
.auth-status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
  .success {
    margin-left: 20px;
    .success-title {
      font-size: 24px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #51c456;
      line-height: 22px;
    }
  }
}
.status-text {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #333333;
  line-height: 22px;
  text-align: center;
  margin-top: 40px;
}
.abtn{
  margin-right: 20px;
}
.button-box {
  width: 178px;
  height: 42px;
  border-radius: 2px;
  border: 1px solid #ff8622;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff8622;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
}
.flex-button {
  display: flex;
  align-items: center;
  padding-top: 30px;
}
.iframe {
  border: none;
  height: 30px;
}
.success-text {
  margin-top: 10px;
}
.btns {
  font-family: Alibaba-PuHuiTi-R;
  background: #ff8622;
  border-radius: 2px;
  color: #ffffff;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/auto/index.vue